import type { z } from 'zod'
import { BillsIndexSchema, BillWithVotesSchema, RecentVotesSchema } from './models'
import type { BillsIndex, BillWithVotes, RecentVotes } from './models'

async function fetchJson<S extends z.ZodType>(path: string, schema: S): Promise<z.infer<S>> {
  let resp: Response
  try {
    resp = await fetch(path)
  } catch (e) {
    throw new Error(`fetch ${path} failed: ${e}`)
  }
  if (!resp.ok) {
    throw new Error(`fetch ${path} failed: HTTP ${resp.status}`)
  }
  let json: unknown
  try {
    json = await resp.json()
  } catch (e) {
    throw new Error(`parse ${path} failed: ${e}`)
  }
  const result = schema.safeParse(json)
  if (!result.success) {
    throw new Error(`parse ${path} failed: ${result.error.message}`)
  }
  return result.data
}

export function fetchRecentVotes(): Promise<RecentVotes> {
  return fetchJson('/data/recent_votes.json', RecentVotesSchema)
}

export function fetchBillsIndex(): Promise<BillsIndex> {
  return fetchJson('/data/bills_index.json', BillsIndexSchema)
}

export function fetchBill(boletin: string): Promise<BillWithVotes> {
  return fetchJson(`/data/bills/${boletin}.json`, BillWithVotesSchema)
}
